export default __webpack_public_path__ + "static/B0282-5ffb723432814cac030b160a0645a0cc.png";